import { CoreIcon } from '../core-icon';
import logoAutopassForInsuranceSVG from '../../assets/logos/logo-autopass-for-insurance.svg';
import type { IconProps } from '../core-icon';

export const LogoAutopassForInsuranceIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={logoAutopassForInsuranceSVG} {...props} />;
};
